import React from "react";
import { CardHeader,Container} from "@material-ui/core";
import { Box,makeStyles,Button,CardActions,Typography,Grid,Card,CardContent} from "@material-ui/core";

const useStyles = makeStyles({
    cardContent: {
      transition: 'transform 0.3s ease-in-out',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    
  });

const tiers = [
    {
      title: 'Rent a Space',
      description: 'Let Sopia’s sophisticated algorithm find an optimal rental space for your company’s needs.We have a full range of commercial real estate available.  A space that you and your colleagues will love!',
      buttonText: 'RENT A SPACE',
      buttonVariant: 'contained',
    },
    {
      title: 'Lease a Space',
      description: 'Property owner, with our largest customer reach and network you’ll find a match for your rental space, with a minimum work load on your side. So that you can focus on your customer success.',
      buttonText: 'LEASE A SPACE',
      buttonVariant: 'contained',
    },
    {
      title: 'See Insights',
      description: 'With more insights about property market and customers than any traditional real estate websites, let us guide you through the underlying needs of both tenants and property owners.',
      buttonText: 'LEARN MORE',
      buttonVariant: 'contained',
    },
  ];
export default function HowSopiaCanHelp() {
    const classes = useStyles();
    return (
        <>
        <Container disableGutters maxWidth="md"  style={{ paddingTop: 8, paddingBottom: 50 }}>
            <Typography
            variant="h3"
            align="center"
            color="secondary"
            style={{fontWeight: 'bold'}}
            gutterBottom
            >
            How Sopia Can Help
            </Typography>
      </Container>
     
      
            <Grid container spacing={5} alignItems="flex-end">
            {tiers.map((tier) => (
                <Grid
                item
                xs={12}
                sm={6}
                md={4}
                >
                    <Card className={classes.cardContent} >
                        <CardHeader
                        title={tier.title}
                        titleTypographyProps={{ align: 'center' }}
                        />
                        <CardContent>
                            <Typography
                                variant="subtitle1"
                                align="center">
                                {tier.description}
                            </Typography>
                        </CardContent>
                     
                            <Box align="center" pb={6}>
                            <Button color="primary" size="medium" variant={tier.buttonVariant}>
                                {tier.buttonText}
                            </Button>

                            </Box>
                            
                        
                    </Card>
                </Grid>
            ))}
            </Grid>
      
      </>
    );
  }
  
 
  
